var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrazado19268(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 41.667,
    viewBox: "0 0 50 41.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19268",
    "data-name": "Trazado 19268",
    d: "M29,47.667a2.1,2.1,0,0,1-1.292-.437C27.125,46.771,13.188,35.813,8.271,30.9A14.584,14.584,0,0,1,28.9,10.271l.1.1.1-.1A14.584,14.584,0,0,1,49.729,30.9C44.813,35.813,30.875,46.75,30.292,47.229A2.1,2.1,0,0,1,29,47.667Zm-10.417-37.5a10.439,10.439,0,0,0-7.375,3.042,10.282,10.282,0,0,0-3.042,7.375,10.4,10.4,0,0,0,3.042,7.375c3.9,3.9,14.167,12.1,17.792,14.979,3.625-2.875,13.9-11.083,17.792-14.979a10.43,10.43,0,0,0-14.75-14.75,11,11,0,0,0-1.313,1.6,2.146,2.146,0,0,1-3.458,0,11,11,0,0,0-1.312-1.6A10.4,10.4,0,0,0,18.583,10.167Z",
    transform: "translate(-4 -6)",
    fill: "#003765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrazado19268);
export default __webpack_public_path__ + "static/media/Trazado 19268.44b07741aaf61231a0f6e65ff5ddd9ea.svg";
export { ForwardRef as ReactComponent };